angular.module('picmonic-common').directive('plsCompile', [
  '$interpolate',
  '$parse',
  function ($interpolate, $parse) {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        elem.html($interpolate($parse(attrs.plsCompile)(scope))(scope));
      },
    };
  },
]);
